
import { Box, Button, Heading, Input } from "@chakra-ui/react";
import { HostSocket, PlayerSocket } from "jparty-shared";
import { useContext, useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";

import { LayoutContext } from "../common/Layout";
import { emitLeaveSession } from "../common/MenuPanel_Settings";
import { getClientID, joinSessionName } from "../../misc/client-utils";
import { isQAPlayer, qaPlayerName, qaSessionName } from "../../misc/qa-dashboard";
import { socket } from "../../misc/socket";
import { LocalStorageKey } from "../../misc/ui-constants";

export default function PlayerLobby() {
    const context = useContext(LayoutContext);
    const [sessionName, setSessionName] = useState(joinSessionName);
    const [playerName, setPlayerName] = useState("");
    const didQAAutoJoinRef = useRef(false);

    useEffect(() => {
        if (!isQAPlayer || !qaSessionName || !qaPlayerName || didQAAutoJoinRef.current || localStorage[LocalStorageKey.SessionName]) {
            return;
        }

        // auto-join the QA session
        didQAAutoJoinRef.current = true;
        socket.emit(PlayerSocket.Connect, qaSessionName, getClientID(), qaPlayerName, () => {});
    }, []);

    const emitConnect = () => {
        socket.emit(PlayerSocket.Connect, sessionName, getClientID(), playerName, (resetSessionName: boolean, resetPlayerName: boolean) => {
            if (resetSessionName) {
                setSessionName("");
            }

            if (resetPlayerName) {
                setPlayerName("");
            }
        });
    }

    const switchToHost = () => {
        context.setIsPlayer(false);
        localStorage.removeItem(LocalStorageKey.IsPlayer);
        emitLeaveSession(true);
        socket.emit(HostSocket.Connect, getClientID());
    }

    return (
        <Box className={"mobile-box"} padding={"1em"}>
            <Heading fontSize={"3em"} className={"logo-text"}>jparty!</Heading>
            {isMobile && "host a session by going to jparty.io on your computer"}

            <Box margin={"0.5em"} />

            <Input placeholder={"session name"} value={sessionName} onChange={(e) => setSessionName(e.target.value)} />
            <Input placeholder={"your name"} value={playerName} onChange={(e) => setPlayerName(e.target.value)} />

            <Box margin={"1em"} />
            <Button isDisabled={!sessionName || !playerName} colorScheme={"blue"} onClick={emitConnect}>join session</Button>
            <Box margin={"0.5em"} />

            {
                !isMobile && (
                    <Box>
                        or, use your computer to host instead:<br />
                        <Button onClick={switchToHost} colorScheme={"blue"} marginTop={"0.25em"}>switch to host</Button>
                    </Box>
                )
            }
        </Box>
    );
}